import { FAQ } from 'pages/LandingPage/FaqSection/types';

export const faqData: FAQ[] = [
  {
    category: 'Sobre o Financiamento',
    question: 'O que é o Financiamento Dimo?',
    answer:
      'Financiamento Dimo é uma forma de adquirir seu smartphone de forma simples e parcelada sem comprometer o limite do seu cartão de crédito.',
  },
  {
    category: 'Sobre o Financiamento',
    question: 'Como posso financiar meu novo smartphone?',
    answer:
      'Você pode financiar seu smartphone em até 18x sem comprometer o limite do cartão de crédito, de forma rápida e simples.',
  },
  {
    category: 'Requisitos',
    question: 'Quais são os requisitos para financiamento?',
    answer:
      'Você precisa ser maior de 23 anos e passar pela análise de crédito realizada no momento da compra. Ter em mãos o seu RG ou CNH originais e dentro da validade, para RG até 10 anos da data de emissão.',
  },
  {
    category: 'Lojas',
    question: 'Eu consigo financiar um smartphone em qualquer loja Motorola?',
    answer:
      'Já são diversas MotoStores que oferecem o financiamento exclusivo do seu smartphone. Clique aqui para encontrar a loja mais próxima.',
  },
  {
    category: 'Análise de Crédito',
    question: 'Será feita análise de crédito para contratação do Financiamento Dimo?',
    answer:
      'Para contratar o financiamento, é feita uma análise de crédito simplificada, ou seja, você informa apenas alguns dados básicos e nós verificamos se está legível para o contrato. Menos burocracia pra você já sair com um smartphone Motorola novinho!',
  },
  {
    category: 'Análise de Crédito',
    question: 'Como saber se fui aprovado no financiamento?',
    answer: 'A aprovação do financiamento é feita na hora, e você será informado pelo consultor da loja.',
  },
  {
    category: 'Pagamento',
    question: 'Preciso de um cartão de crédito para financiar?',
    answer:
      'Não, o Financiamento Dimo permite que você financie seu smartphone sem precisar de um cartão de crédito. E o pagamento é debitado direto da sua conta Dimo.',
  },
  {
    category: 'Pagamento',
    question: 'Preciso pagar uma entrada para contratar o Financiamento Dimo?',
    answer: 'Sim. A entrada é definida de acordo com a análise de crédito.',
  },
  {
    category: 'Pagamento',
    question: 'Como faço para pagar as parcelas do meu Financiamento Dimo?',
    answer:
      'É muito simples e você faz tudo pelo aplicativo Dimo! O pagamento das parcelas é debitado automaticamente do seu saldo, então é só deixar o valor reservado próximo da data de vencimento e deixar o resto com a gente!',
  },
  {
    category: 'Pagamento',
    question: 'Quando vou pagar a primeira parcela do meu Financiamento Dimo?',
    answer:
      'Você só paga a primeira parcela 30 dias após da contratação. Assim, você pode se planejar e reservar o valor no saldo da sua conta Dimo com tranquilidade.',
  },
  {
    category: 'Conta Dimo',
    question: 'Não tenho conta Dimo. O que eu faço?',
    answer:
      'Fique tranquilo que no momento da contratação do financiamento sua conta será aberta, de forma fácil e rápida.',
  },
  {
    category: 'Inadimplência',
    question: 'O que acontece se eu não pagar uma parcela?',
    answer: 'Caso não efetue o pagamento de uma parcela, seu smartphone pode ser bloqueado até a regularização.',
  },
  {
    category: 'Inadimplência',
    question: 'Como funciona o bloqueio do smartphone?',
    answer:
      'Se as parcelas não forem pagas, seu smartphone pode ser bloqueado remotamente até a regularização do pagamento.',
  },
  {
    category: 'Limites',
    question: 'Eu posso contratar mais de um Financiamento Motorola no meu CPF?',
    answer:
      'Não. No momento, só é possível a contratação ativa de um Financiamento por CPF. Mas quando o contrato for finalizado, você pode comprar outro smartphone Motorola através dessa forma de pagamento.',
  },
  {
    category: 'Quitação',
    question: 'Eu posso quitar o meu Financiamento Dimo?',
    answer:
      'Sim! Você pode quitar o seu financiamento a qualquer momento. Para solicitar a emissão do boleto para realizar o pagamento, é só entrar em contato com a nossa Central de Atendimento WhatsApp: (11) 5194-5196, horários de segunda a sexta, das 9hrs às 17hrs45.',
  },
  {
    category: 'Privacidade',
    question: 'Como posso acessar a política de privacidade?',
    answer:
      'Você pode acessar a política de privacidade da Motorola através do link: https://help.motorola.com/hc/apps/privacy/web/pt-br/',
  },
];
